import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Container, Column, Row } from "./Grid";

// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
const LoaderContext = React.createContext();

type LoadingProps = {
  id?: string;
  className?: string;
  withText?: boolean;
};

function Loading({ id, className, withText }: LoadingProps) {
  return (
    <div id={id} data-testid={id} className={`loader ${className}`}>
      {withText && (
        <span>
          <FormattedMessage id="general.loading" />
        </span>
      )}
      <div className="icon-spinner-dark" />
    </div>
  );
}

type LoaderProps = {
  id?: string;
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
  withText?: boolean;
};

function Loader({
  id,
  loading,
  children,
  className = "",
  withText = true,
}: LoaderProps) {
  const [loadingState, setLoadingState] = useState(0);
  const setLoading = (state: $TSFixMe) => {
    if (state) {
      setLoadingState(loadingState + 1);
    } else {
      setLoadingState(Math.max(loadingState - 1, 0));
    }
  };

  if (children) {
    return (
      <>
        <LoaderContext.Provider value={setLoading}>
          {children}
        </LoaderContext.Provider>
        {loadingState > 0 || loading ? (
          <Container>
            <Row>
              <Column>
                <div className="space-before" />
                <Loading id={id} className={className} withText={withText} />
              </Column>
            </Row>
          </Container>
        ) : null}
      </>
    );
  }

  return loading ? (
    <Loading id={id} className={className} withText={withText} />
  ) : null;
}

const withLoader = (ChildComponent: $TSFixMe) => {
  function ConnectedComponent(props: $TSFixMe) {
    return (
      <LoaderContext.Consumer>
        {(context) => <ChildComponent {...props} setLoading={context} />}
      </LoaderContext.Consumer>
    );
  }
  return ConnectedComponent;
};

export { withLoader };

export default Loader;
